var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"inner"},[_c('h1',[_vm._t("title")],2),_c('div',{staticClass:"prev"},[_c('router-link',{attrs:{"to":"/202007"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }